import React from "react";
import { Spin } from "antd";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { IAttachmentTypePresenter } from "../../../attachmentType/presenter/AttachmentTypePresenter";
import AttachmentTypeGrid from "../components/AttachmentTypeGrid";
export interface Props extends PageProps {}

export interface State extends IAttachmentTypePresenter {}

export default class AttachmentTypePage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      createAttachmentType,
      attachmentTypes,
      contentTypes,
      updateAttachmentType,
      organisations
    } = this.state;

    return (
      <Page {...this.props} className={"content-wrapper"}>
        {
          <Spin spinning={this.state.loaders.attachmentTypeLoader}>
            <AttachmentTypeGrid
              organisations={organisations}
              translate={translate}
              createAttachmentType={createAttachmentType}
              attachmentTypes={attachmentTypes}
              contentTypes={contentTypes}
              updateAttachmentType={updateAttachmentType}
            />
          </Spin>
        }
      </Page>
    );
  }
}
